<ng-container *ngIf="vm$ | async as vm">
  <h1 class="head1">Kalender</h1>

  <app-zitting-list class="zitting__list" [zittingen]="vm.zittingen"></app-zitting-list>

  <div class="pager-row">
    <button type="button" role="link" tabindex="0" (click)="navigateToArchief()" class="btn btn-default pager-button-col">Archief</button>
  </div>
</ng-container>